<template>
  <a-button
    @click="(e) => $emit('click', e)"
    class="btn google-btn"
    icon="google"
    :disabled="disabled"
    >Google</a-button
  >
</template>

<script>
export default {
  props: ['disabled'],
};
</script>

<style lang="scss">
@import '~@/assets/styles/colors';

.google-btn {
  color: $red;
  border-color: $red;
}

.google-btn i {
  margin-top: 2px;
  content: url('~@/assets/icons/google-icon.svg');
}
</style>
